export default "__VITE_ASSET__15ea4e7e__"